import React from "react";
import Header from "../../Header/Header";
import topFrame from "./Frame 3.png";
import HomeInspectorConfirmation from "./../../../assets/images/HomeInspectorConfirmation.png";

import { useNavigate } from "react-router-dom";
const ConfirmationPreparation = () => {
    const navigate = useNavigate();

    return (
        <div className="tw-min-h-screen tw-pt-[55px] tw-h-full tw-bg-gray-100 tw-overflow-auto">
            <span className="">
                <Header title="Insurance Services Confirmation" />
            </span>
            <div className="tw-max-w-full  tw-h-full  tw-mx-auto tw-flex tw-flex-col tw-items-center tw-justify-between ">
                <div></div>
                <div className="tw-flex  tw-flex-col  lg:tw-max-w-[70%] tw-bg-white tw-rounded-xl tw-w-[90%] ">
                    <div className="tw-flex tw-justify-center tw-mt-3">
                        <img src={HomeInspectorConfirmation} className="tw-w-[150px]" alt="" />
                    </div>

                    <div className="tw-rounded-lg tw-py-8 max-md:tw-px-8 tw-px-24 max-sm:tw-px-5 ">
                        <div className="tw-text-center tw-mb-4 ">
                            <h1 className="tw-text-2xl tw-font-bold tw-text-gray-800 tw-mb-2 ">Your home inspection is scheduled!</h1>
                            <p className="tw-text-gray-600 tw-text-[16px] tw-font-bold">
                                Our team has scheduled your inspection. you'll receive a confirmation email shortly with all the details
                            </p>
                        </div>

                        <div className="tw-space-y-6 tw-mb-4 tw-text-center tw-flex tw-justify-center">
                            <p className="tw-text-gray-700  tw-max-w-[920px] tw-font-medium tw-leading-tight">
                                Thank you for taking the time to provide your information. Our network of top-rated insurance providers is now working
                                on customized quotes for your property. Here’s what you can expect:{" "}
                            </p>
                        </div>

                        <div className="tw-flex tw-flex-col tw-items-center lg:tw-flex-nowrap tw-gap-4">
                            <button
                                onClick={() => {
                                    sessionStorage.removeItem("insuranceInfo");
                                    navigate("/properties");
                                }}
                                className="tw-bg-primary hover:tw-bg-primary_hover tw-w-fit tw-px-[50px] lg:tw-px-[100px] tw-text-white tw-h-[52px] tw-rounded-lg tw-transition-colors tw-text-sm"
                            >
                                Return To Home Screen
                            </button>
                            <p className="tw-text-gray-700 tw-text-center">
                                Your information is securely stored and processed in compliance with data protection regulartions.{" "}
                            </p>
                        </div>
                    </div>
                </div>
                <div></div>
            </div>
        </div>
    );
};

export default ConfirmationPreparation;
